<template>
  <div id="app">
    <router-view />
    <prompt></prompt>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import prompt from './components/prompt.vue'
export default {
  components: {
    prompt
  },
  data () {
    return {
      status: '',
      isFirst: false,
      name: 'App',
      timer: null,
      previous: null,
      token: ''
    }
  },
  // 监听器
  watch: {
    $route (to, from) {
      let { isFreeAuth } = this.$store.getters
      console.log('isFreeAuth =>', isFreeAuth)
      if (isFreeAuth === -1 || isFreeAuth === true) {
        // 短视频才有
        // this.checkAuth()
      }
      if (to.path === '/survey/index') {
        this.remind()
      }
      // 监听路由是否变化
      if (to.path === '/diy/list' || to.path === '/diy/edit') {
        // 跳转到哪个页面
        this.mergeLocaleMessage()
      }
    }
  },
  created () {
    this.mergeLocaleMessage()
  },
  mounted () {
    let that = this
    window.onresize = () => {
      that.fnThrottle(() => {
        let clientWidth = document.documentElement.clientWidth
        if (clientWidth < 1200) {
          that.$store.commit('handleAdSwitch', false)
        }
      }, 300)()
    }
  },
  methods: {
    ...mapMutations(['changePromptData', 'changeIsShowPrompt']),
    async checkAuth () {
      let {code, data} = await this.$api.baseCheckAuth()
      if (code !== 200) return
      // data 0未授权 1已授权
      this.$store.dispatch('changeItem', { key: 'isFreeAuth', val: data === 0 })
    },
    remind () {
      setTimeout(() => {
        this.token = sessionStorage.getItem('minitk')
        if (this.token) {
          this.$api.getAgentAuthStatus().then(res => {
            this.changePromptData(res.data)
            this.status = res.data.status
          })
        } else {
          this.remind()
        }
      }, 1000)
    },
    async mergeLocaleMessage () {
      let zh = {
        menu: {}
      }
      let { data } = await this.$api.returnJson()
      let name = {
        1: '名片',
        2: '商城',
        3: '动态',
        4: '官网'
      }
      data.list.map(item => {
        if (item.name !== name[item.key]) {
          name[item.key] = item.name
        }
      })
      // 名片
      // zh.menu.BusinessCard = `${name[1]}`
      // zh.menu.CardSetting = `${name[1]}设置`
      // zh.menu.CardInfo = `${name[1]}信息`
      // zh.menu.CardManage = `${name[1]}管理`
      // zh.menu.StaffCard = `员工${name[1]}`
      // zh.menu.EditCard = `编辑${name[1]}`
      // 商城
      // zh.menu.Malls = `${name[2]}`
      // zh.menu.MallsManage = `${name[2]}管理`
      // zh.menu.MallsSet = `${name[2]}设置`
      // zh.menu.MallsBanner = `${name[2]}轮播图`
      // 动态
      // zh.menu.Dynamic = `${name[3]}`
      // zh.menu.DynamicSet = `${name[3]}设置`
      // zh.menu.DynamicManage = `${name[3]}管理`
      // zh.menu.EditOrdinary = `编辑普通${name[3]}`
      // zh.menu.EditLink = `编辑链接${name[3]}`
      // zh.menu.EditVideo = `编辑视频${name[3]}`
      // zh.menu.DynamicClassifySet = `${name[3]}分类设置`
      // 官网
      zh.menu.Website = `${name[4]}`
      zh.menu.WebsiteManage = `${name[4]}管理`
      zh.menu.WebSiteInfo = `${name[4]}信息`
      zh.menu.WebsiteColumn = `${name[4]}栏目`
      this.$i18n.mergeLocaleMessage('zh', zh)
    },
    fnThrottle (fn, delay, atleast) {
      let that = this
      return function () {
        let now = +new Date()
        if (!that.previous) that.previous = now
        if (atleast && now - that.previous > atleast) {
          fn()
          that.previous = now
          clearTimeout(that.timer)
        } else {
          clearTimeout(that.timer)
          that.timer = setTimeout(function () {
            fn()
            that.previous = null
          }, delay)
        }
      }
    }
  }
}
</script>

<style lang='scss'>
  @import url("./style/reset.css");
  @import url("./style/icon.css");
  @import url("./style/base.css");
  @import url("./style/diy.css");
  @import url("./style/common.css");
</style>



// WEBPACK FOOTER //
// src/App.vue